export default "__VITE_ASSET__29d7a419__"